// extracted by mini-css-extract-plugin
module.exports = {"content":"TimeoutWarningModal_content__3JAXW","backdrop":"TimeoutWarningModal_backdrop__2mARF","body":"TimeoutWarningModal_body__1F-rD"};